<template>
  <div class="overlay-area">
    <!-- 原始內容區域 -->
    <div
      class="overlay-content"
      :class="{ 'overlay-content-disabled': isActive }"
      :style="contentStyle"
    >
      <slot />
    </div>

    <!-- 覆蓋層 -->
    <div v-if="isActive" class="overlay-mask" :style="maskStyle">
      <!-- 自定義覆蓋內容 -->
      <slot name="overlay" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'OverlayArea',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Number,
      default: 0.5,
      validator: (value) => value >= 0 && value <= 1,
    },
    zIndex: {
      type: Number,
      default: 1000,
    },
  },
  setup (props) {
    const isActive = computed(() => props.active)

    const contentStyle = computed(() => ({
      opacity: isActive.value ? props.opacity : 1,
      transition: 'opacity 0.3s ease',
    }))

    const maskStyle = computed(() => ({
      backgroundColor: `rgba(255,255,255, ${props.opacity})`,
      zIndex: props.zIndex,
    }))

    return {
      isActive,
      contentStyle,
      maskStyle,
    }
  },
})
</script>

<style lang="postcss" scoped>
.overlay-area {
  @apply relative;
}

.overlay-content {
  @apply transition-opacity duration-300 ease-in-out;
}

.overlay-content-disabled {
  @apply pointer-events-none select-none;
}

.overlay-mask {
  @apply absolute inset-0 flex items-center justify-center pointer-events-auto;
}
</style>
